//api url
export const API_URL = process.env.REACT_APP_API_URL;

//development environment
export const MODE = process.env.REACT_APP_MODE;

//development environment
export const CT_ORDER_URL = process.env.REACT_APP_CT_ORDER_URL;

// configurable order for Services tiles (comma-separated template_service_id list)
// e.g., REACT_APP_SERVICES_ORDER="12,5,9"
// Keep as strings to avoid any numeric coercion surprises.
export const SERVICES_ORDER = (process.env.REACT_APP_SERVICES_ORDER || '')
	.split(',')
	.map((v) => String(v).trim())
	.filter((s) => s.length > 0);